// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface BackIconSignature {
  Element: SVGSVGElement;
}

export const BackIcon: TOC<BackIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 3H4C2.897 3 2 3.896 2 5V19C2 20.103 2.897 21 4 21H6C7.103 21 8 20.103 8 19V5C8 3.896 7.103 3 6 3ZM17.772 5.466C18.361 5.007 19.211 4.921 19.879 5.249C20.56 5.582 21 6.287 21 7.045V16.955C21 17.713 20.56 18.418 19.88 18.752C19.183 19.093 18.368 18.997 17.773 18.535L11.401 13.578C10.91 13.196 10.629 12.621 10.629 12C10.629 11.379 10.91 10.803 11.4 10.422L17.772 5.466ZM12.629 12.001L19 16.956V7.045L12.629 12.001ZM4 5V19H6.001L6 5H4Z"/>
</svg>
</template>;